import { MouseEventHandler, ReactNode } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './info-block.style';

export interface ISharedTypes {
  large?: boolean;
  disabled?: boolean | null;
}

interface IProps extends ISharedTypes {
  icon?: ReactNode;
  text: string;
  onClick?: MouseEventHandler<ReactNode>;
}

const InfoBlock = ({ icon, text, onClick, large, disabled }: IProps) => {
  const styles = componentStyles({ large, disabled });

  return (
    <Box style={styles.wrapper} onClick={onClick}>
      {icon && <Box style={styles.iconWrap}>{icon}</Box>}
      <Box style={styles.textWrap}>{text}</Box>
    </Box>
  );
};

export default InfoBlock;
